import { render, staticRenderFns } from "./ToggleSingleOrMultiPaymentMethod.vue?vue&type=template&id=897a8b64&scoped=true&"
import script from "./ToggleSingleOrMultiPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ToggleSingleOrMultiPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSingleOrMultiPaymentMethod.vue?vue&type=style&index=0&id=897a8b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897a8b64",
  null
  
)

export default component.exports